import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BxCardComponent, BxCardHeaderComponent } from '@beyonnex/bx-angular-ui';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductStatusBadgeComponent } from '../../../components/product-status-badge/product-status-badge.component';
import { CommonTranslateService } from '../../../services/common-translate/common-translate.service';
import { PRODUCT_COLUMNS } from '../../product-view/property-overview/property-overview.models';
import { PropertyDetailsStore } from '../property-details.store';

@Component({
  selector: 'bxi-property-product-status',
  imports: [BxCardComponent, BxCardHeaderComponent, ProductStatusBadgeComponent, TranslatePipe],
  templateUrl: './property-product-status.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyProductStatusComponent {
  private readonly store = inject(PropertyDetailsStore);
  private readonly commonTranslate = inject(CommonTranslateService);

  private readonly propertyStatus = toSignal(this.store.propertyStatus$);

  /** One column per product in the design's order; a product the billing unit does not serve has no status. */
  protected readonly columns = computed(() => {
    const products = this.propertyStatus()?.products;

    return PRODUCT_COLUMNS.map((product) => ({ product, status: products?.find((entry) => entry.product === product) }));
  });

  protected readonly hasProducts = computed(() => !!this.propertyStatus()?.products.length);

  protected readonly translateAbbreviation = this.commonTranslate.translateProductAbbreviation;
  protected readonly translateName = this.commonTranslate.translateProductName;
}
